import React, { useEffect } from 'react';
import { API } from '../../API';
import { notify } from 'react-notify-toast';
import Spinner from '../../Components/Spinner/Spinner';

function OAuth2Callback() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    if (!code) {
      notify.show("Authorize error. Please try again later")
      setTimeout(() => {
        window.location = "/"
      }, 300)
      return
    }

    const pathRedirect = localStorage.getItem("authorizedRedirectPath") || "/"
    localStorage.removeItem("authorizedRedirectPath")

    API.getTokenGoogleDrive(code)
      .then((response) => {
        const data = response?.data?.data

        localStorage.setItem("googleDriveToken", data?.token)
        localStorage.setItem("googleDriveTokenExp", data?.expiry_date)

        notify.show("Authorize Successfully")
        setTimeout(() => {
          window.location = pathRedirect
        }, 300)
      })
      .catch((error) => {
        console.log(`⚡️[log]: †††††† ~ error: `, error);

        notify.show("Authorize Error. Please try again later")
        setTimeout(() => {
          window.location = pathRedirect
        }, 300)
      })
  }, []);

  return <Spinner/>
}

export default OAuth2Callback;
